/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {addAccountToAccountHolderInternal} from '../api'

export const useMutationAddAccountToAccountHolderInternal = createReactQueryMutationHook('addAccountToAccountHolderInternal', addAccountToAccountHolderInternal)
